var contactModule = function(){
	var scope = ".js-mod-contact";
	ui.ready(
        scope,
		function($contact){
		    var $contactForm = $contact.find(scope+"__form");
            $contactForm.submit(
                function(ev){
					ev.preventDefault();
					var $button = $contactForm.find(scope+"__button");
					var isOk = $contactForm.checkRestrictions();
                    if(isOk){
                        $button.prop("disabled",true);
                        gvf.endpoint("\\controller\\web\\contactController::sendContactForm",
                            [$contactForm.getValues()],
                            function(response){
                                $button.prop("disabled",false);
                                if(response.status=="ok"){

                                    Swal.fire(
                                        {
                                            text: response.message,
                                            type: "success",
                                            icon: "success"
                                        }
                                    ).then(function (result){
                                            if(result.isConfirmed){
                                                window.location.reload();
                                            }
                                        }
                                    )
                                }else{
                                    utils.alertEndpointResponse(response);
                                }
                            }
                        );
                    }
                }
            );
		}
	);
}();

